import { render, staticRenderFns } from "./CustomDisplayElementManifestConfig.vue?vue&type=template&id=0f4d1174&scoped=true&lang=html"
import script from "./CustomDisplayElementManifestConfig.vue?vue&type=script&lang=js"
export * from "./CustomDisplayElementManifestConfig.vue?vue&type=script&lang=js"
import style0 from "./CustomDisplayElementManifestConfig.vue?vue&type=style&index=0&id=0f4d1174&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4d1174",
  null
  
)

export default component.exports